module.exports = {
        srcSet: "/_next/static/images/google@3x-130-721eaaa333265d24.png"+" 130w"+","+"/_next/static/images/google@3x-260-89f2bf20a796e096.png"+" 260w"+","+"/_next/static/images/google@3x-390-f4f6691ed215a3e4.png"+" 390w",
        images: [{path: "/_next/static/images/google@3x-130-721eaaa333265d24.png",width: 130,height: 39},{path: "/_next/static/images/google@3x-260-89f2bf20a796e096.png",width: 260,height: 78},{path: "/_next/static/images/google@3x-390-f4f6691ed215a3e4.png",width: 390,height: 117}],
        src: "/_next/static/images/google@3x-390-f4f6691ed215a3e4.png",
        toString: function(){return "/_next/static/images/google@3x-390-f4f6691ed215a3e4.png"},
        
        width: 390,
        height: 117
      }